import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { inlineMediaUrl } from '../../inlineMediaUrl';
import { SerializedReel } from '../../types';
import { reelProgressMessages } from './reelProgressMessages';
import { reelReviewMessages } from './reelReviewMessages';
import { ReelMetaChips } from './ReelMetaChips';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the preview, the history and the sheets */
import styles from './ReelReview.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ReelPreviewProps {
  reel: SerializedReel;
  releaseTitle?: string;
}

/**
 * The 9:16 player of a finished reel (design c1, c2) and its chips. It plays `video.url` with
 * `video.posterUrl` as the poster. A Free reel has the watermark in the video itself, so the app
 * draws nothing on top.
 */
const ReelPreviewComponent: React.FC<ReelPreviewProps> = ({ reel, releaseTitle }) => {
  const intl = useIntl();
  const { video } = reel;
  const label = intl.formatMessage(reelReviewMessages.player, {
    release: releaseTitle ?? intl.formatMessage(reelProgressMessages.thisRelease),
  });

  return (
    <div className={styles.media}>
      {video === null ? (
        <div className={styles.video} role="img" aria-label={label} />
      ) : (
        // eslint-disable-next-line jsx-a11y/media-has-caption -- the captions are burnt into the video
        <video
          className={styles.video}
          src={inlineMediaUrl(video.url)}
          poster={video.posterUrl === null ? undefined : inlineMediaUrl(video.posterUrl)}
          aria-label={label}
          controls
          playsInline
          preload="metadata"
        />
      )}
      <ReelMetaChips reel={reel} />
    </div>
  );
};

export const ReelPreview = TypedMemo(ReelPreviewComponent);
